module.exports = __webpack_public_path__ + "img/图1-9尺寸界线.14065d7d.jpg";